import { findUrl } from './findUrl'
import urlSlug from 'url-slug'
import { GRADO } from '../utils/variables/gatsbyNodeVariables'

export const createNavigationUrl = (matchPages, relations) => {
  if (relations.p_ucc_page) return findUrl(relations.p_ucc_page.slug, matchPages)

  if (relations.p_ucc_career) return `/carreras/${relations.p_ucc_career.slug}`

  if (relations.p_ucc_microsite) return `/${relations.p_ucc_microsite.slug}`

  if (relations.novelty) return `/noticias/${relations.novelty.slug}`

  // if (relations.diary) return `/agenda/${relations.diary.slug}`

  if (relations.url) return relations.url

  if (relations.career_level)
    return `/propuesta-academica/${
      relations.career_level.name.toLowerCase() === GRADO
        ? 'carreras'
        : urlSlug(relations.career_level.name)
    }`

  return '/'
}